module.exports = __webpack_public_path__ + "static/nat-gif-f0bdeb2bd448f5b4f80d1d882b3b38ed.gif";